// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ef1e68c","455":"03b0da61"}[chunkId] + ".chunk.js";
};